export const SAVE_ALL_BANK_BALANCES = 'SAVE_ALL_BANK_BALANCES'